/**
 * 获取Cookie数据
 */
export function getCookie(name) {
  const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  const arr = document.cookie.match(reg)
  if (arr) { return unescape(arr[2]); } else return null;
}
// cookie相关操作
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString(); }
}

export function setCookie(name, value, days = 30) {
  var exp = new Date();
  exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie =
      name +
      '=' +
      escape(value) +
      ';expires=' +
      exp.toGMTString() +
      '; path=/;';
}